import {IconCPU, IconFan, IconGOML, IconGPU, IconMBO, IconRAM} from "./icons";

export const PREFIX_EFFECT = 'effect_';

export const TYPE_CASE = 'case';
export const TYPE_BUNDLE = 'bundle';
export const TYPE_GPU = 'gpu';
export const TYPE_CPU = 'cpu';
export const TYPE_MBO = 'mbo';
export const TYPE_RAM = 'ram';
export const TYPE_FAN = 'fan';
export const TYPE_SSD = 'ssd';
export const TYPE_CHARGE = 'netzteil';
export const TYPE_SOUND = 'sound';
export const TEXT_GOMLVL_SHORT = 'Gomlvl';
export const TEXT_GOMLVL_LONG = 'Getonmylvl';
export const TEXT_EMPTY = '?';
export const TABS = [
  {
    name: TYPE_BUNDLE,
    iconData: {IconComponent: IconGOML, height: 34},
    text: 'edition',
  },
  {
    name: TYPE_GPU,
    iconData: {IconComponent: IconGPU, height: 34},
    text: 'grafikkarte',
  },
  /* Temporary is out */
  // {
  //   name: TYPE_CPU,
  //   iconData: {IconComponent: IconCPU, height: 25},
  //   text: 'prozessor',
  // },
  {
    name: TYPE_MBO,
    iconData: {IconComponent: IconMBO, height: 25},
    text: 'mainboard',
  },
  {
    name: TYPE_RAM,
    iconData: {IconComponent: IconRAM, height: 15},
    text: 'ram',
  },
  {
    name: TYPE_FAN,
    iconData: {IconComponent: IconFan, height: 22},
    text: 'lüfter',
  },
];

export const PROPERTY_VISIBLE = 'visible';
export const PROPERTY_ACTIVE = 'active';
export const PROPERTY_CLASS_NAME = 'className';

export const TEXT_SECONDS_SINGLE = 'Sekunde';
export const TEXT_SECONDS_PLURAL = 'Sekunden';

export const TEXT_MORE_QUESTIONS = 'Weitere Fragen?';
export const TEXT_HAVE_MORE_QUESTIONS = 'Du hast noch weitere Fragen?';
export const TEXT_FIND_IN_SHOP = 'Finde Deine Edition im Shop';
